export default __webpack_public_path__ + "static/media/1.709a0825.webp";